import {FACTION_CONFIGS} from "../../configs/factions";

export const getFactionConfig = (id) => {
  return FACTION_CONFIGS.find(config => config.id === id);
}